import React, { memo } from 'react';

import classes from './helpCenterArticle.module.css';

interface Props {
  id: string;
  title: string;
  body: string;
}

const HelpCenterArticle = memo(
  ({ id, title, body }: Props) => (
    <div id={`article-${id}`} className={classes.card} data-article-id={id}>
      <h2 className={classes.title}>{title}</h2>
      {/* eslint-disable-next-line react/no-danger */}
      <div className={classes.body} dangerouslySetInnerHTML={{ __html: body }} />
    </div>
  ),
  (prev, next) => prev.id === next.id && prev.title === next.title && prev.body === next.body
);

HelpCenterArticle.displayName = 'HelpCenterArticle';

export { HelpCenterArticle };
